import { useEffect, useRef } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { getPhilosophyPage, loadPhilosophyPage } from "../flow-loader";

/**
 * Lazy shell for the /philosophy chunk - same lean imperative-mount pattern
 * and deferred hydration boundary as FlowPage (see that file for the
 * TASK-SSR-002 deep-link adopt flow, and tasks/bugs/open/BUG-COMPILER-020
 * for why the mount is imperative).
 */
export default function PhilosophyPage() {
  const host = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let dead = false;
    let root: any = null;
    const mount = (page: any) => {
      if (dead || !host.current) return;
      if (host.current.hasChildNodes()) {
        root = hydrateRoot(host.current, page);
      } else {
        root = createRoot(host.current);
        root.render(page);
      }
    };
    const cached = getPhilosophyPage();
    if (cached) mount(cached);
    else loadPhilosophyPage().then(mount);
    return () => {
      dead = true;
      if (root) root.unmount();
    };
  }, []);

  return <div ref={host} data-jethydrate="defer" />;
}
